/**
 * Why something that needs Docker cannot run here (utils/runnablesModel.js dockerOffMessage): where this Flow has no
 * Docker support (`reason` 'cluster') "Ask your Flow admin" and nothing else; where the plan does not include "Docker
 * in the sandbox" (or the pod did not say), the plan's message and Change plan. The caller wraps it (its test id).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { dockerOffMessage, noDockerPlanChange } from '../../utils/runnablesModel';
import { PlanChangeButton } from '../sandbox/PlanRequest';

export default function NoDockerNote({ reason = null }) {
  return (
    <>
      {dockerOffMessage(reason)}
      {noDockerPlanChange(reason) && <>{' '}<PlanChangeButton /></>}
    </>
  );
}

NoDockerNote.propTypes = {
  reason: PropTypes.oneOf(['cluster', 'plan', null]),
};
